/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';
import type { DatabaseFontSizeEnum } from './DatabaseFontSizeEnum';
import {
    DatabaseFontSizeEnumFromJSON,
    DatabaseFontSizeEnumFromJSONTyped,
    DatabaseFontSizeEnumToJSON,
} from './DatabaseFontSizeEnum';
import type { DatabaseKlappzeile } from './DatabaseKlappzeile';
import {
    DatabaseKlappzeileFromJSON,
    DatabaseKlappzeileFromJSONTyped,
    DatabaseKlappzeileToJSON,
} from './DatabaseKlappzeile';
import type { DatabasePageBlockActionType } from './DatabasePageBlockActionType';
import {
    DatabasePageBlockActionTypeFromJSON,
    DatabasePageBlockActionTypeFromJSONTyped,
    DatabasePageBlockActionTypeToJSON,
} from './DatabasePageBlockActionType';
import type { DatabaseTextPageBlock } from './DatabaseTextPageBlock';
import {
    DatabaseTextPageBlockFromJSON,
    DatabaseTextPageBlockFromJSONTyped,
    DatabaseTextPageBlockToJSON,
} from './DatabaseTextPageBlock';

/**
 * 
 * @export
 * @interface DatabaseNamePageBlock
 */
export interface DatabaseNamePageBlock extends DatabaseTextPageBlock {
}

/**
 * Check if a given object implements the DatabaseNamePageBlock interface.
 */
export function instanceOfDatabaseNamePageBlock(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseNamePageBlockFromJSON(json: any): DatabaseNamePageBlock {
    return DatabaseNamePageBlockFromJSONTyped(json, false);
}

export function DatabaseNamePageBlockFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseNamePageBlock {
    return json;
}

export function DatabaseNamePageBlockToJSON(value?: DatabaseNamePageBlock | null): any {
    return value;
}

